import React from "react";
import { IbanElement } from "@stripe/react-stripe-js";

function SupportSEPAPayment() {
  return (
    <div>
      <IbanElement
        options={{
          supportedCountries: ["SEPA"],
        }}
      />
    </div>
  );
}

export default SupportSEPAPayment;
